import { render, staticRenderFns } from "./PayrollHistoryList.vue?vue&type=template&id=d6d9f2fa&scoped=true"
import script from "./PayrollHistoryList.vue?vue&type=script&lang=ts"
export * from "./PayrollHistoryList.vue?vue&type=script&lang=ts"
import style0 from "./PayrollHistoryList.vue?vue&type=style&index=0&id=d6d9f2fa&prod&scoped=true&lang=css"
import style1 from "./PayrollHistoryList.vue?vue&type=style&index=1&id=d6d9f2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d9f2fa",
  null
  
)

export default component.exports